module.exports = __webpack_public_path__ + "static/media/insight.7a9436e8.svg";